import { useCallback, useEffect } from "react";

import { useLensSubmissionRoutesV3 } from "../../core/routes/hooks";
import { useSnapSSOAuthService } from "../../core/sso-auth";

import { useSubmitLensConfiguration } from "./useSubmitLensConfiguration";

export const useSelectSubmitAccount = (
    submissionId: string,
): {
    signOut: () => void;
    submitWithDifferentUser: () => void;
} => {
    const authService = useSnapSSOAuthService();

    const {
        setSubmitUnderDifferentUser,
        submitLensState: { submitUnderDifferentUser },
    } = useSubmitLensConfiguration();

    const { goToFlowRedirector: goToFlowRedirectorV3 } = useLensSubmissionRoutesV3();

    useEffect(() => {
        if (submitUnderDifferentUser) {
            goToFlowRedirectorV3(submissionId);
        }
    }, [submitUnderDifferentUser, submissionId, goToFlowRedirectorV3]);

    const submitWithDifferentUser = useCallback(() => {
        setSubmitUnderDifferentUser(true);
    }, [setSubmitUnderDifferentUser]);

    const signOut = useCallback(() => {
        authService.logout().catch(() => {
            // TODO - Error handling
        });
    }, [authService]);

    return {
        signOut,
        submitWithDifferentUser,
    };
};
